<template>
  <div class="campusIdManage">
    <div class="breadcrumb">个性化组件</div>
    <div class="search">
      类型：
      <el-select v-model="status" @change="bindStatus">
        <el-option label="全部状态" value="0"></el-option>
        <el-option label="未操作" value="1"></el-option>
        <el-option label="已通过" value="2"></el-option>
        <el-option label="未通过" value="3"></el-option>
      </el-select>
      <el-button class="addBtn" type="primary" @click="openAddDialog"
        >新增</el-button
      >
    </div>

    <div class="com-list">
      <el-table :data="list" style="overflow-x: auto">
        <el-table-column prop="index" label="序号" width="80px;">
        </el-table-column>
        <el-table-column prop="name" label="类型"> </el-table-column>
        <el-table-column prop="phone" label="名称"> </el-table-column>
        <el-table-column label="图像">
          <template slot-scope="scope">
            <img
              class="el-table-img"
              @click="
                openImgDialog(
                  'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
                )
              "
              src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
              alt=""
            />
          </template>
        </el-table-column>
        <el-table-column prop="appealTime" label="同类型排序">
        </el-table-column>
        <el-table-column prop="appealTime" label="目前使用量">
        </el-table-column>
        <el-table-column prop="appealTime" label="涉及学生"> </el-table-column>
        <el-table-column prop="appealTime" label="最新操作"> </el-table-column>
        <el-table-column label="状态" inline-template>
          <div>
            <span v-if="row.status == '1'">已发布</span>
            <span v-if="row.status == '2'">未发布</span>
          </div>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == '1'"
              class="option"
              type="text"
              @click="editItem(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.status == '1'"
              class="option"
              type="text"
              @click="publishItem(scope.row)"
              >发布</el-button
            >
            <el-button
              v-if="scope.row.status == '1'"
              class="option"
              type="text"
              @click="deleteItem(scope.row)"
              >删除</el-button
            >
            <el-button
              v-if="scope.row.status == '2'"
              class="option"
              type="text"
              @click="openDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              v-if="scope.row.status == '2'"
              class="option"
              type="text"
              @click="cancelItem(scope.row)"
              >撤销</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-show="this.totalCount > 0"
          layout="prev, pager, next, jumper"
          :page-size="20"
          :current-page="currentPage"
          :total="totalCount"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="
        edit ? '编辑个性化组件' : read ? '查看个性化组件' : '新增个性化组件'
      "
      v-if="dialogVisible"
      v-model="dialogVisible"
      :modal-append-to-body="false"
      :before-close="closeDialog"
    >
      <el-form :disabled="disable" :model="form" ref="form" id="addForm">
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input placeholder="请输入序号" v-model="totalCount"></el-input>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input
            :disabled="disabled"
            v-model="totalCount"
            placeholder="请输入高校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="图像" :label-width="formLabelWidth">
          <el-input
            v-model="totalCount"
            placeholder="请输入高校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="同类型排序" :label-width="formLabelWidth">
          <el-input
            v-model="totalCount"
            placeholder="请输入高校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="目前使用量" :label-width="formLabelWidth">
          <el-input
            v-model="totalCount"
            placeholder="请输入高校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="涉及学生" :label-width="formLabelWidth">
          <el-input
            v-model="totalCount"
            placeholder="请输入高校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="最新操作" :label-width="formLabelWidth">
          <el-input
            v-model="totalCount"
            placeholder="请输入高校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <el-input
            v-model="totalCount"
            placeholder="请输入高校名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="addcampus">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogImgVisible"
      v-model="dialogImgVisible"
      :modal-append-to-body="false"
    >
      <img style="width: 100%; height: 100%" :src="dialogImg" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      totalCount: 0,
      status: this.$util.getUrlParam("status") || "0",
      type: this.$util.getUrlParam("keyType") || "1",
      keyWord: this.$util.getUrlParam("keyword") || "",
      currentPage: this.$util.getUrlParam("pageNum") * 1 || 1,
      dialogVisible: false,
      dialogImgVisible: false,
      dialogImg: "",
      form: {},
      edit: false,
      read: false,
      disabled: true,
    };
  },
  mounted() {
    if (this.$util.getUrlParam("pageNum")) {
      setTimeout(() => {
        let currentPage = this.$util.getUrlParam("pageNum") * 1;
        location.href = "#/userM/campusIdManage";
        this.currentPage = currentPage;
        this.getList();
      }, 100);
    } else {
      this.getList();
    }
  },
  computed: {
    placeholder() {
      if (this.type === "1") {
        return "请输入手机号";
      } else if (this.type === "2") {
        return "请输入姓名";
      } else {
        return "请输入学号";
      }
    },
  },
  methods: {
    closeDialog() {
      // 关闭时将状态数据初始化
      this.read = false;
      this.edit = false;
      this.disabled = false;
      this.dialogVisible = false;
    },
    editItem() {
      // 编辑操作
      this.dialogVisible = true;
      this.read = true;
      this.form = row;
    },
    publishItem() {
      // 发布操作
      this.$confirm("是否发布此数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "发布成功!",
          });
        })
        .catch(() => {
          return;
        });
    },
    deleteItem() {
      // 删除操作
      this.$confirm("是否删除此数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          return;
        });
    },
    openDetail(row) {
      // 打开详情
      this.dialogVisible = true;
      this.disabled = true;
      this.read = true;
      this.form = row;
    },
    cancelItem(row) {
      // 撤销操作
      this.$confirm("是否撤销此数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "撤销成功!",
          });
        })
        .catch(() => {
          return;
        });
    },
    bindStatus(value) {
      console.log(value);
      this.getList(value);
    },
    openAddDialog() {
      this.dialogVisible = true;
    },
    openImgDialog(data) {
      this.dialogImgVisible = true;
      this.dialogImg = data;
    },
    search() {
      this.getList();
    },
    detail(row) {
      let params = {
        id: row.id,
        status: this.status,
        pageNum: this.currentPage,
        keyType: this.keyType,
        keyword: encodeURI(this.keyWord.trimLeft()),
      };
      this.$util.refreshTo("/#/userM/campusIdDetail", params);
    },
    //获取个性化列表
    getList(status) {
      let url = this.$util.domain + "/adminapi/v3/user/campusidfindback/list";
      //0,忽略关键字;
      let keyType = this.keyWord ? this.type * 1 : 0;
      this.$http({
        url,
        method: "POST",
        body: JSON.stringify({
          keyType,
          status: this.status * 1,
          keyword: this.keyWord,
          pageSize: 20,
          pageNum: this.currentPage,
        }),
      }).then(
        (response) => {
          this.list = [];
          if (response.data.error == 10000) {
            let dataList = response.data.data.dataList;
            this.totalCount = response.data.data.totalCount;
            if (dataList) {
              if (dataList.length > 0) {
                dataList.forEach((item, index) => {
                  this.list.push({
                    index: index + 1,
                    name: item.name,
                    phone: item.phone,
                    campusId: item.campusId,
                    appealTime: new Date(item.appealTime).format("yyyy/MM/dd"),
                    status: item.status,
                    id: item.id,
                  });
                });
              }
            }
          } else {
            this.$util.errorMsg(response.data.message);
          }
        },
        (response) => {
          this.$util.errorMsg(response.data.message);
        }
      );
    },
    //请求分页数据
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-table-img {
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-top: 10px;
}
.addBtn {
  float: right;
  margin-right: 20px;
}
.campusIdManage .el-select {
  display: inline-block;
}

.campusIdManage .el-input {
  display: inline-block;
  width: auto;
}

.campusIdManage .el-button {
  display: inline-block;
}

.campusIdManage .el-button + .el-button {
  margin-left: 0;
}

.search {
  margin-left: 30px;
  margin-bottom: 20px;
}
.search::after {
  clear: both;
}

.el-dialog__body p {
  line-height: 38px;
}
</style>



// WEBPACK FOOTER //
// specific.vue?d2ee6af8